import useClients from '@gr/portal/hooks/useClients';
import { Dropdown } from '@Wonder-Cave/ui';
import { IDropdownValue } from '../Dropdown';

interface IClientDropdownProps {
  value: IDropdownValue | (IDropdownValue | undefined)[] | undefined;
  onChange: (newValue: IDropdownValue | (IDropdownValue | undefined)[] | undefined) => void;
  onBlur?: () => void;
  allClients?: boolean;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError?: boolean;
  gridFilter?: boolean;
  multiple?: boolean;
  placeholder?: string;
  label?: string;
  noLabel?: boolean;
  gray?: boolean;
  shimmer?: boolean;
}

const ClientDropdown = ({
  value,
  onChange,
  onBlur,
  allClients = false,
  showError,
  disabled,
  errorMessage,
  gridFilter,
  multiple = false,
  placeholder,
  label,
  gray = false,
  noLabel = false,
  shimmer,
}: IClientDropdownProps): JSX.Element => {

  const { query: clientsQuery } = useClients();
  const clients: IDropdownValue[] =
    clientsQuery.data?.records.map((client) => ({
      label: client.name ?? '',
      value: gridFilter ? client.name ?? '' : client.id ?? '',
      additionalData: {
        clickerGroup: client.defaultClickerGroupId,
        twoWayEnabled: client.twoWayEnabled,
      },
    })) ?? [];

  return !multiple ? (
    <Dropdown
      gray={gray}
      label={!noLabel ? label ?? 'Client' : ''}
      loading={clientsQuery.isPending}
      value={value as IDropdownValue}
      options={!allClients ? clients?.filter((x) => x.value !== '11111111-1111-1111-1111-111111111111') ?? [] : clients}
      onChange={onChange}
      onBlur={onBlur}
      error={errorMessage}
      disabled={disabled}
      showError={showError}
      placeholder={placeholder}
      shimmer={shimmer}
    />
  ) : (
    <Dropdown
      multiple
      gray={gray}
      loading={clientsQuery.isPending}
      label={!noLabel ? label ?? 'Client' : ''}
      value={value as IDropdownValue[]}
      options={!allClients ? clients?.filter((x) => x.value !== '11111111-1111-1111-1111-111111111111') ?? [] : clients}
      onChange={onChange}
      onBlur={onBlur}
      error={errorMessage}
      disabled={disabled}
      showError={showError}
      placeholder={placeholder}
      shimmer={shimmer}
    />
  );
};

export default ClientDropdown;
